<script>
    import { locationStore, startLocationTracking, stopLocationTracking } from "./locationStore.js"
    import { onMount, onDestroy } from "svelte"

    let locationData

    // Überwachung der Standortdaten beim Laden der Komponente starten
    onMount(() => {
        startLocationTracking()
        const unsubscribe = locationStore.subscribe((value) => {
            locationData = value
        })

        // Standortüberwachung stoppen, wenn die Komponente zerstört wird
        return () => {
            stopLocationTracking()
            unsubscribe()
        }
    })
</script>
